import { Button } from '@thanx/uikit/button'
import Modal from 'components/Modal'
import { buildTranslate } from 'locales'
import { MultiUseRewardsSettings } from 'scenes/RedeemManager/Builder/FormModel'

type Props = {
  isOpen: boolean
  onClose: () => void
  onOkay: () => Promise<void>
  multiUseSettings?: MultiUseRewardsSettings
  hasMultiUseChanges?: boolean
}

const t = buildTranslate('redeem_manager.change_active_template_modal')

export default function ChangeActiveTemplateModal({
  isOpen,
  onClose,
  onOkay,
  multiUseSettings,
  hasMultiUseChanges = false,
}: Props) {
  const renderMultiUseChangedContent = () => {
    const { maxIssuancesPerWindow, windowDuration, maxIssuances } =
      multiUseSettings!

    // Handle singular vs plural
    const timesText =
      maxIssuancesPerWindow === 1
        ? t('multi_use_once')
        : t('multi_use_times', { times: maxIssuancesPerWindow })

    const daysText =
      windowDuration === 1
        ? t('multi_use_daily')
        : t('multi_use_every_days', { days: windowDuration })

    let usageText =
      t('multi_use_can_redeem_base') + ' ' + timesText + ' ' + daysText + ','

    if (maxIssuances) {
      usageText += t('multi_use_up_to_total', { times: maxIssuances })
    }

    usageText += ' ' + t('multi_use_set_duration')

    return (
      <>
        <p className="mb-m">{usageText}</p>
        <p className="mb-m">{t('changes_apply')}</p>
        <p className="mb-0">
          <strong>{t('note_label')}</strong> {t('multi_use_reached_limit')}
        </p>
      </>
    )
  }

  const shouldShowMultiUseContent =
    hasMultiUseChanges &&
    multiUseSettings &&
    multiUseSettings.usageType === 'multiple_times'

  return (
    <Modal show={isOpen} onModalClose={onClose}>
      <div className="d-flex flex-column p-xl">
        <h3 className="mt-0 mb-l extra-bold">{t('title')}</h3>
        <div className="mb-l body-text-3 grey-70">
          {shouldShowMultiUseContent ? (
            renderMultiUseChangedContent()
          ) : (
            <p className="mb-0">{t('changes_apply')}</p>
          )}
        </div>
        <div className="d-flex justify-content-end">
          <Button kind="secondary" onClick={onClose} className="mr-s">
            {t('cancel')}
          </Button>
          <Button onClick={onOkay}>{t('okay')}</Button>
        </div>
      </div>
    </Modal>
  )
}
